const assetLoadPromisesByLang = new Map<string, Promise<void>>();
let lastLoadedLang: string | null = null;

export const loadAllAssetsDataOnce = async (lang: string): Promise<void> => {
  const { assetsModule }: any = await import("@/store");

  const isAssetResourcesLoadedForLang = (): boolean => {
    const hasTags = Array.isArray(assetsModule.getTags) && assetsModule.getTags.length > 0;
    const hasAssets = Array.isArray(assetsModule.getAssets) && assetsModule.getAssets.length > 0;
    const hasAlbums = Array.isArray(assetsModule.getAlbumsWithoutAssets) && assetsModule.getAlbumsWithoutAssets.length > 0;

    return lastLoadedLang === lang && hasTags && hasAssets && hasAlbums;
  };

  const alreadyLoaded = isAssetResourcesLoadedForLang();

  if (alreadyLoaded) return;

  const isLoadingNow = assetLoadPromisesByLang.get(lang);

  if (isLoadingNow) return isLoadingNow;

  const performAssetLoad = async (lang: string) => {
    try {
      await assetsModule.LoadAssetResourcesByLang(lang);
      lastLoadedLang = lang;
    } catch (error) {
      assetLoadPromisesByLang.delete(lang);
      throw error;
    }
  };

  const loadingPromise = performAssetLoad(lang);
  assetLoadPromisesByLang.set(lang, loadingPromise);

  await loadingPromise;
};
